import AppForm from '../app-components/Form/AppForm';
import {cloneDeep} from 'lodash';
import {normalizeFormValue} from '../utils.js';

var userLanguage = document.documentElement.lang;
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component('employee-contract-form', {
    mixins: [AppForm],
    props: {
        'data': {
            type: Object,
            required: false,
            default: function() {
                return {};
            }
        },
        'contracts':{
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'allContractTypes': {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'contractTypes': {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'workingFundTypes': {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'restaurants':{
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'dynamicAdditions':{
            type: Object,
            required: false,
            default: function() {
                return {};
            }
        },
        'currentRestaurant': {
            //type: Number,
            required: false
        },
        'employeeId': {
            //type: Number,
            required: false
        },
        'currentContractId': {
            //type: Number,
            required: false,
            default: function() {
                return null;
            }
        },
        'defaultSalaryVariableWage': {
            type: Number,
            required: false,
            default: function() {
                return 0;
            }
        },
        'restaurantContractTypesUrl': {
            type: String
        },
        'mode': {
            type: String
        },
        'mymcdSync': {
            type: Boolean,
            required: false,
            default: function() {
                return null;
            }
        },
        'trans': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        }
    },
    data: function() {
        return {
            employeeContractFormLoading: false,
            originalContracts: [],
            mutableCurrentContractId: null,
            mutableAction: this.action,
            mutableContracts: cloneDeep(this.contracts),
            invalidContractIds: [],
            serverFieldErrors: {},
            invalidContractRules: {},
            mutableContractTypes: this.contractTypes,
            currentRestaurantIdForContractSelectbox: this.currentRestaurant,
            formMode: this.mode,
            defaultForm: {
                is_draft: true,
                id:  null,
                parent_id: null,
                restaurant_id:  this.currentRestaurant,
                position_id:  1,
                contract_type_id:  this.getCurrentContractId(),
                salary_type:  'monthly',
                salary:  null ,
                working_fund_in_hours:  null,
                working_fund_type:  'daily',
                date_signed:  null ,
                date_start:  null ,
                date_end:  null ,
                wage_personal_number: null,
                salary_addition: {
                    uniform: 0,
                    night_shift: 0,
                    meal_vouchers: 0,
                    meal_vouchers_type: 1,
                    public_holiday: 0,
                    saturday: 0,
                    sunday: 0,
                    overtime: 0,
                    travel_expenses: 0,
                },
                dynamic_additions: [],
                default_salary_variable_wage: this.defaultSalaryVariableWage,
                dynamicFieldsValues: {}
            },
            form: {},
            newContractForm: {
                type: 'new'
            },
            newContractFormErrors: [],
            // debounced wage personal number checks by contract id
            checkWagePersonalNumberTimeouts: {},

            datePickerConfig: {
                dateFormat: 'Y-m-d 00:00:00',
                altInput: true,
                altFormat: 'd.m.Y',
                locale: userLanguage,
                allowInput: true,
                onClose(dates, currentdatestring, picker){
                    picker.setDate(picker.altInput.value, true, picker.config.altFormat);
                }
            },
        }
    },

    created: function created() {
        if (!!this.locales && this.locales.length > 0) {
            this.currentLocale = this.defaultLocale;
        }

        this.mutableContractTypes = this.contractTypes;
        this.setCurrentContract(this.currentContractId);

        window.addEventListener('resize', this.onResize);

        if (this.formMode == 'edit' && this.mutableContracts.length > 0)
        {
            this.form = this.mutableContracts.find(c => c.restaurant_id === parseInt(this.currentRestaurant))
        }
        else {
            var initialContract = cloneDeep(this.defaultForm);
            initialContract.id = -1;
            initialContract.restaurant_id = this.currentRestaurant;
            initialContract.contract_type_id = this.contractTypes[0].key;

            this.mutableContracts.push(initialContract);
            this.form = this.mutableContracts.find(c => c.id == -1); // tu sa straca referencia na mutableContract objekt (z this.form) a pri validaci/prepinani dochadzka k strate dat

            var _this = this;
            setTimeout(function() {
                _this.form = _this.mutableContracts.find(c => c.id == -1);
            },200);

        }

        /*if(this.form.restaurant_id !== this.currentRestaurant) {
            this.mutableContractTypes = this.allContractTypes.filter(ct => ct.restaurant === this.form.restaurant_id)
        }
        console.log(this.mutableContractTypes);*/
        // we need to persist initial state of every contract
        for(var x in this.contracts)
        {
            this.originalContracts.push(cloneDeep({ ...this.contracts[x]}));
        }

        this.form.default_salary_variable_wage = this.sanitizeFloatInput((this.form.default_salary_variable_wage ? this.form.default_salary_variable_wage : 0), 2);

        this.$validator.extend('contract_range', {
            getMessage(field, params, data) {
                return (data && data.message) || 'Invalid range';
            },
            validate: (value, args) => {
                return {
                    valid: this.getOverlapingContracts().length <= 1,
                    data: { message: $("#date_start").data("error-overlaps") }
                };
            }
        });

        var transErrors = this.trans.errors;
        this.$validator.extend('date_before_start', {
            getMessage(field, params, data) {
                return transErrors.date_before_start;
            },
            validate: (value, vm) => {
                return _moment(value) >= _moment(this.form.date_start);
            }
        });

        this.$validator.extend('validate_work_fund', {
            getMessage(field, params, data) {
                return transErrors.work_fund;
            },
            validate: (value, vm) => {
                if(this.form.is_draft || !this.hasFundHours()) {
                    return true;
                }

                let adtValidations = false;
                switch(this.form.working_fund_type) {
                    case 'daily':
                        adtValidations = value > 0 && value <= 15;
                        break;
                    case 'weekly':
                        adtValidations = value > 0 && value <= 80;
                        break;
                    case 'monthly':
                        adtValidations = value > 0 && value <= 300;
                        break;
                }

                return value !== '' && parseFloat(value) > 0 && adtValidations;
            }
        });
    },

    filters: {
        date: function date(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

            var date = (0, _moment2.default)(date);
            return date.isValid() ? date.format(format) : "";
        },
    },

    methods: {
        getCurrentValidationRules() {
            if (!this.$validator || !this.$validator.errors || !this.$validator.errors.items) {
                return [];
            }

            return [...new Set(this.$validator.errors.items.map(item => item.rule).filter(Boolean))];
        },

        revalidateContractDateFields() {
            if (!this.$validator || !this.form) {
                return;
            }

            this.$nextTick(() => {
                Promise.all([
                    this.$validator.validate('date_start', this.form.date_start),
                    this.$validator.validate('date_end', this.form.date_end),
                ]).then(() => {
                    this.$validator.validateAll().then(result => {
                        if (this.form.id === null || typeof this.form.id === 'undefined') {
                            return;
                        }

                        if (result === false && !this.invalidContractIds.includes(this.form.id)) {
                            this.invalidContractIds.push(this.form.id);
                        }

                        if (result === false) {
                            this.$set(this.invalidContractRules, this.form.id, this.getCurrentValidationRules());
                        }

                        if (result === true) {
                            this.invalidContractIds = this.invalidContractIds.filter(contractId => contractId !== this.form.id);
                            this.$delete(this.invalidContractRules, this.form.id);
                        }
                    });
                });
            });
        },

        isMymcdSyncEnabled: function(value) {
            return value === true || value === 1 || value === '1' || value === 'true';
        },

        showModal(contractId, url) {
            this.$modal.show('delete-employee-contract-form', {contractId: contractId, url: url});
        },

        preventSubmit(event) {  // deprecated - probably not used, anymore (replaced with same method in FormEmployeeWithContract.js)
            if (event) event.preventDefault();
            if (event) event.stopPropagation();

            console.sentryMessage("Form.js > preventSubmit(e) - deprecated method still used");
        },

        getOverlapingContracts() {
            const rangeNew = moment.range(this.form.date_start, (this.form.date_end === null ? '2099-12-31 23:59:59' : this.form.date_end));
            //.filter(contract => contract.id !== this.form.id)
            return this.getActiveContracts().filter(contract => {
                        const rangeExist = moment.range(contract.date_start, (contract.date_end === null ? '2099-12-31 23:59:59' : contract.date_end));
                        return rangeNew.overlaps(rangeExist, { adjacent: true });
                   })
                    .map(c => moment(c.date_start).format("D.M.Y")+" - "+(c.date_end ? moment(c.date_end).format("D.M.Y") : "..."));
        },


        getActiveContracts() {
            return this.mutableContracts.filter(c => c.is_draft === false);
        },

        getExistingContracts() {
            return this.mutableContracts.filter(ele => ele.id !== -1).sort((a, b) => a.date_start < b.date_start );
        },

        getChildContracts(parentId) {
            return this.mutableContracts.filter(c => c.parent_id === parentId).sort((a, b) => a.date_start < b.date_start );
        },

        getLatestActiveInterval(parentId)
        {
            var contractsFiltered = this.mutableContracts.filter(c => c.is_draft === false);
            if(parentId)
            {
                contractsFiltered = contractsFiltered.filter(c => c.parent_id === parentId);
            }

            var result = contractsFiltered.sort(function(a,b) {
                if (a.date_start == b.date_start)
                    return 0;

                return (a.date_start > b.date_start ? -1 : 1);
            });

            return (result ? result[0] : null);
        },


        getContractInRestaurant(restaurantId) {
            return this.mutableContracts.filter(ele => (ele.restaurant_id == restaurantId && ele.id !== -1));
        },

        loadAvailableContractsForRestaurant(restaurantId)
        {
            this.mutableContractTypes = this.allContractTypes.filter(ct => ct.restaurant === parseInt(restaurantId));
        },

        changeRestaurantInContract() {
            this.loadAvailableContractsForRestaurant(this.form.restaurant_id);
            this.form.contract_type_id = null;
        },

        getRestaurantName(contractId)
        {
            const contract = this.mutableContracts.find(c => c.id === contractId);
            if (!contract) {
                return "";
            }

            const restaurant = this.restaurants.find(r => parseInt(r.id) === parseInt(contract.restaurant_id));
            if (restaurant) {
                return restaurant.title;
            }

            if (contract.restaurant && contract.restaurant.title) {
                return contract.restaurant.title;
            }

            return "";
        },

        getContractTypeLabel(contractId,altName)
        {
            const contractTypeId = this.mutableContracts.find(c => c.id === contractId).contract_type_id;
            if(contractTypeId)
            {
                const ctrt = this.allContractTypes.find(ct => ct.key == contractTypeId);
                return (ctrt ? ctrt.shortcode : altName);
            }
            return altName;
        },

        isParentContractDisabled(contract)
        {
            if (!contract || contract.parent_id !== null) {
                return false;
            }

            const allowedRestaurantIds = this.restaurants.map(r => parseInt(r.id));
            return !allowedRestaurantIds.includes(parseInt(contract.restaurant_id));
        },

        moreRestaurantsWithContracts()
        {
            var foundRestaurantIds = [];
            for(var x in this.mutableContracts)
            {
                if(!foundRestaurantIds.includes(this.mutableContracts[x].restaurant_id))
                {
                    foundRestaurantIds.push(this.mutableContracts[x].restaurant_id);
                }
            }
            return foundRestaurantIds.length > 1;
        },

        getPostData() {
            return this.mutableContracts.filter(c => this.isContractModified(c) === true);
        },

        modalCreateNewContractSubmit(e) {
            if(!this.validateNewContractModal())
            {
                e.preventDefault();
                return false;
            }

            var newContract = null;

            // contract addition for latest contract (we have to copy data from latest addition of that contract, but parent will be the original contract)
            if(this.newContractForm.type == 'child')
            {
                const latest = this.getLatestActiveInterval();
                newContract = this.createNewContractItem(latest, this.newContractForm.date_start, latest.restaurant_id, (latest.parent_id ? latest.parent_id : latest.id));
            }

            // new contract, with copy_from
            else if(this.newContractForm.copy_from != 0)
            {
                var copyFrom = this.mutableContracts.find(c => c.id == this.newContractForm.copy_from);

                if(copyFrom.childs.length > 0)
                {
                    copyFrom = this.getLatestActiveInterval(copyFrom.id);
                }

                newContract = this.createNewContractItem(copyFrom, this.newContractForm.date_start, this.newContractForm.restaurant, null);
            }

            // new contract, empty  -> some additional modifications (ex.: set restaurant)
            else
            {
                newContract = this.createNewContractItem(this.defaultForm, this.newContractForm.date_start, this.newContractForm.restaurant, null);

                // toto neviem z akého dôvodu sem bolo pridané Janči, keď restaurant id nastavuješ na riadku vyššie
                // z modalu a potom hneď ho prepíšeš na restaurant id z posledného aktívneho contractu, ale budem
                // predpokladať, že nejaký dôvod to malo, tak sem pridám len podmienku, že ak na novom contracte
                // objecte nie je restaurant tak ju až vtedy natiahni z posledného aktívneho contractu

                if(this.newContractForm.restaurant === null) {
                    newContract.restaurant_id = this.getLatestActiveInterval().restaurant_id;
                }
            }


            // modify latest open contract date_end to -1 day of newContract
            const latestOpened = this.getLatestActiveInterval();
            if(latestOpened && (!latestOpened.date_end || !_moment(latestOpened.date_end).isBefore(_moment(this.newContractForm.date_start))))
            {
                this.mutableContracts.find(c => c.id === latestOpened.id).date_end = _moment(this.newContractForm.date_start).add(-1, 'days').format("YYYY-MM-DD HH:mm:ss");
            }

            this.mutableContracts.push(newContract);
            this.setCurrentContract(newContract.id);
        },

        createNewContractItem(copyFrom, dateStart, restaurantId, parentId)
        {
            const newContract = cloneDeep(copyFrom);
            newContract.id = -1;
            newContract.is_active = false;
            newContract.childs = [];
            newContract.date_signed = dateStart;
            newContract.date_start = dateStart;
            newContract.restaurant_id = copyFrom.restaurant_id;
            newContract.parent_id = parentId;
            newContract.contract_type_id = (copyFrom.restaurant_id != restaurantId ? null : copyFrom.contract_type_id);
            //newContract.wage_personal_number = null; // DA-563: copy also wage number - always (also on new contracts, because they can be only with same restaurant_id - it's disabled in contract form)

            if(!parentId) { // reset only if it is a new contract
                newContract.date_end = null;
                // TODO or NOT TODO: only if dateStart is < than this date_end, otherwise reset to null, too
            }

            if(typeof newContract.salary_addition == "undefined") newContract.salary_addition = Object.assign({}, this.defaultForm.salary_addition);
            if(typeof newContract.dynamicFieldsValues == "undefined") newContract.dynamicFieldsValues = cloneDeep(this.defaultForm.dynamicFieldsValues);
            if(typeof newContract.default_salary_variable_wage == "undefined") newContract.default_salary_variable_wage = this.defaultForm.default_salary_variable_wage;

            return newContract;
        },

        closeNewContractModal() {
            this.$refs.modalNewContract.hide();
        },

        newContract() {
             this.mutableCurrentContractId = null;
             this.setCurrentContract(-1);
        },

        getCurrentContract(){
           var currentContractId = this.mutableCurrentContractId;
           var currentContract = null;
           if (currentContractId){
                currentContract = this.mutableContracts.filter(function(ele){
                   return (ele.id == currentContractId)
                });
           }
           if (currentContract && currentContract.length){
               currentContract = currentContract[0];
           }
           return currentContract;
        },

        setCurrentContract(id) {

           this.mutableCurrentContractId = (id !== null && id !== undefined) ? parseInt(id) : null;
           var currentContract = this.getCurrentContract();
        //    this.$validator.errors.clear();

           if (currentContract)
           {
               this.form = currentContract; // Object.assign({}, currentContract);
               this.mutableAction = currentContract.resource_url;
               this.currentRestaurantIdForContractSelectbox = currentContract.restaurant_id;

               this.loadAvailableContractsForRestaurant(currentContract.restaurant_id);

                this.$validator.validateAll().then(result => {
                    if (result === false && !this.invalidContractIds.includes(id)) {
                        this.invalidContractIds.push(id)
                    }

                    if (result === false) {
                        this.$set(this.invalidContractRules, id, this.getCurrentValidationRules());
                    }

                    if (result === true) {
                        this.invalidContractIds = this.invalidContractIds.filter(contractId => contractId !== id);
                        this.$delete(this.invalidContractRules, id);
                    }
                });
            }
           else
           {
               this.form = Object.assign({}, this.defaultForm);
               this.mutableAction = this.action;
               this.form.restaurant_id = this.currentRestaurantIdForContractSelectbox;
           }

           // correct decimal format
           this.form.default_salary_variable_wage = this.sanitizeFloatInput((this.form.default_salary_variable_wage ? this.form.default_salary_variable_wage : 0), 2);
        },

        getCurrentContractId() {
            var currentContract = (this.form ? this.form.contract_type_id : null);

            if(currentContract == null)
            {
                // mutable sa nenačitajú včas a nastáva error - fallback
                if(this.mutableContractTypes)
                {
                    currentContract = this.mutableContractTypes[0].key;
                }
                else {
                    currentContract = this.contractTypes[0].key;
                }
            }

            return currentContract;
        },

        getCurrentContractSettings() {
            var currentContractId = this.getCurrentContractId();

            var currentContractType = this.mutableContractTypes.filter(function(ele){
                return (ele.key == currentContractId);
            });

            return (currentContractType && typeof currentContractType[0] != 'undefined' ? currentContractType[0].settings : null);
        },

        salaryAdditionVisible(key,saCfgIsVisible) {
            var currentContractSettings = this.getCurrentContractSettings();

            var isVisibleByContract = !currentContractSettings ||
                                      this.salaryAdditionFilterBySettings(key, currentContractSettings);

            return saCfgIsVisible && isVisibleByContract;
        },

        salaryAdditionAddonClass(key, type)
        {
            var currentContractSettings = this.getCurrentContractSettings();

            // default
            var className = (type=='percent' ? 'fa-percent' : (type=='hour' ? 'fa-clock' : 'fal fa-coins'));

            // overrides by addition key
            switch(key)
            {
                case 'night_shift':
                    className = (currentContractSettings && parseInt(currentContractSettings.nightshiftSalaryAdditionInPercent) == 1 ? "fa-percent" : className);
                    break;
            }

            return className;
        },

        salaryAdditionTypeBySettings(type,contractSettings)
        {
            switch(type)
            {
                case 'night_shift':
                    type = (parseInt(contractSettings.nightshiftSalaryAdditionInPercent) == 1 ? "percent" : type);
                    break;
            }

            return type;
        },

        salaryAdditionFilterBySettings(key,contractSettings)
        {
            var state = false;
            switch(key)
            {
                case 'saturday':
                case 'sunday':
                    state = parseInt(contractSettings.allowSalaryAdditionWeekend) == 1;
                    break;

                case 'meal_vouchers':
//                case 'meal_vouchers_type':
                    state = (parseInt(contractSettings.mealVoucherClaim) == 1 && parseInt(contractSettings.mealVoucherType) == 1) ||
                            ((parseInt(contractSettings.mealVoucherType) == 2 || parseInt(contractSettings.mealVoucherType) == 3) && parseInt(contractSettings.mealVoucherValueSource) == 2);
                    break;

                case 'uniform':
                    state = parseInt(contractSettings.uniformBonusAllow) == 1;
                    break;

                case 'travel_expenses':
                    state = parseInt(contractSettings.allowTravelAllowance) == 1;
                    break;

                // here is the place for filling new conditions :)

                default:
                    state = true;
                    break;
            }

            return state;
        },

        hasFundHours() {
            let currentContractSettings = this.getCurrentContractSettings();
            return (currentContractSettings && parseInt(currentContractSettings.fundHoursType) === 1);
        },

        isDefaultSalaryVariableWageVisible()
        {
            var currentContractSettings = this.getCurrentContractSettings();
            return (currentContractSettings && parseInt(currentContractSettings.salaryVariableWageAllow) == 1);
        },

        isSalaryVariableWageLabelHourly()
        {
            var currentContractSettings = this.getCurrentContractSettings();
            return this.isDefaultSalaryVariableWageVisible() && currentContractSettings && parseInt(currentContractSettings.salaryVariableWageType) == 1;
        },

        isDynamicAdditionVisible(typeId)
        {
            var currentContractSettings = this.getCurrentContractSettings();
            var adtItem = this.dynamicAdditions[typeId];

            return currentContractSettings && adtItem && parseInt(currentContractSettings[adtItem.setting]) != 0
                && this.isDynamicAdditionShownOnContract(currentContractSettings, adtItem.setting);
        },

        isDynamicAdditionShownOnContract(contractSettings, settingName)
        {
            // the option is a setting of the contract type on its own (see App\Enums\DynamicAdditionOption)
            var value = contractSettings[settingName + 'ShowOnContract'];

            return value === undefined || value === null || Number(value) !== 0;
        },

        isDynamicAdditionHourly(typeId)
        {
            var currentContractSettings = this.getCurrentContractSettings();
            var adtItem = this.dynamicAdditions[typeId];

            return currentContractSettings && adtItem && parseInt(currentContractSettings[adtItem.setting]) == 1;  // 1=hourly; 2=monthly
        },

        sanitizeDecimalPoint(val)
        {
            val = ""+val;
            return (val ? val.replace(",",".") : val);
        },

        sanitizeIncorrectFloatChars(val)
        {
            val = this.sanitizeDecimalPoint(val);
            return (val ? val.replace(/[^0-9\.]/,"").replace(/([0-9]+\.[0-9]+)\..*/,"$1") : val);
        },

        sanitizeFloatInput(val,minDecimals)
        {
            if(val == null) return val;

            var sanitized = parseFloat(this.sanitizeIncorrectFloatChars(val));
            if((sanitized || sanitized===0) && this.countDecimals(sanitized) < minDecimals)
                sanitized = sanitized.toFixed(minDecimals);

            return sanitized+"";
        },

        countDecimals(value)
        {
            if(Math.floor(value) === value) return 0;
            var arr = value.toString().split(".");

            return arr.length == 2 ? arr[1].length : 0;
        },

        formatSalaryAdditionPercentage(vmodelName,$event) {
            this.form.salary_addition[vmodelName] = this.sanitizeFloatInput($event.target.value,0);
        },

        formatSalaryAdditionPrice(vmodelName,$event) {
            this.form.salary_addition[vmodelName] = this.sanitizeFloatInput($event.target.value,2);
        },

        correctSalaryAdditionDecimals(vmodelName,$event)
        {
            this.form.salary_addition[vmodelName] = this.sanitizeDecimalPoint($event.target.value);
        },

        formatDynamicAdditionAmount(typeId,$event) {
            let sanitized = this.sanitizeFloatInput($event.target.value,2);
            if(sanitized+""=="NaN") sanitized = "0.00";

            this.form.dynamic_additions[typeId] = sanitized;
            $("#dyn_addition_"+typeId).val(sanitized); // lebo vue je dementne a model sice refreshne, ale input s v-model uz nie
        },

        formatDynamicFieldsAmount(typeId,$event) {
            let sanitized = this.sanitizeFloatInput($event.target.value,2);
            if(sanitized+""=="NaN") sanitized = "0.00";

            this.form.dynamicFieldsValues[typeId] = sanitized;
            $("#field_"+typeId).val(sanitized); // lebo vue je dementne a model sice refreshne, ale input s v-model uz nie
        },

        formatDate(v) {
            return moment(v).format('DD.MM.YYYY');
        },

        correctDynamicAdditionDecimals(typeId,$event)
        {
            this.form.dynamic_additions[typeId] = this.sanitizeDecimalPoint($event.target.value);
        },

        correctDynamicFieldsDecimals(typeId,$event)
        {
            this.form.dynamicFieldsValues[typeId] = this.sanitizeDecimalPoint($event.target.value);
        },

        correctBasicInputDecimals(vmodelName,$event)
        {
            this.form[vmodelName] = this.sanitizeDecimalPoint($event.target.value);
        },
        correctBasicInputAmount(vmodelName,$event)
        {
            this.form[vmodelName] = this.sanitizeFloatInput($event.target.value,2);
        },

        // check this form instantly
        validatorValidateForm()
        {
            return this.$validator.validateAll();
        },

        // check all contracts separatelly
        validatorValidateAllContracts()
        {
            this.invalidContractIds = [];
            this.invalidContractRules = {};
            const origFormRefId = this.form.id;

            // HACK: by setting current contract we trigger validation
            this.getModifiedContracts().forEach(c => {
                this.setCurrentContract(c.id);
            });

            this.setCurrentContract(origFormRefId);

            return new Promise((resolve, reject) => {
                // DANGER: ugly race condition resolution (validation may still be running)
                setTimeout(() => {
                    const allContractFormsAreValid = this.invalidContractIds.length === 0;
                    resolve(allContractFormsAreValid);
                }, 300)
            });
        },

        hasContractErrors(ctr)
        {
            const contractRangeRules = ['contract_range', 'date_before_start'];
            const storedRules = this.invalidContractRules[ctr.id] || [];
            const hasOnlyRangeStoredErrors = storedRules.length > 0 && storedRules.every(rule => contractRangeRules.includes(rule));
            const hasStoredErrors = this.invalidContractIds.includes(ctr.id) && (!hasOnlyRangeStoredErrors || this.hasContractRangeError(ctr));

            const hasCurrentContractValidationErrors =
                this.form &&
                this.form.id === ctr.id &&
                this.$validator &&
                this.$validator.errors &&
                this.$validator.errors.items &&
                this.$validator.errors.items.length > 0;

            return hasStoredErrors
                || this.hasContractRangeError(ctr)
                || hasCurrentContractValidationErrors
                || this.visibleServerFieldErrors(ctr).length > 0;
        },

        hasContractRangeError(ctr)
        {
            if (!ctr || ctr.is_draft || !ctr.date_start) {
                return false;
            }

            const rangeCurrent = moment.range(ctr.date_start, (ctr.date_end === null ? '2099-12-31 23:59:59' : ctr.date_end));

            return this.mutableContracts
                .filter(contract => contract.id !== ctr.id && contract.is_draft === false && contract.date_start)
                .some(contract => {
                    const rangeOther = moment.range(contract.date_start, (contract.date_end === null ? '2099-12-31 23:59:59' : contract.date_end));
                    return rangeCurrent.overlaps(rangeOther, {adjacent: true});
                });
        },

        isContractModified(ctr)
        {
            var mutable = this.mutableContracts.find(c => c.id === ctr.id);
            var original = this.originalContracts.find(c => c.id === ctr.id);

            if(!original || !mutable)
                return true;

            if(original.date_end === null)
                original.date_end = "";

            if(mutable.date_end === null)
                mutable.date_end = "";

            return !this.compareObjects(original,mutable) || !this.compareObjects(mutable, original);
        },

        getModifiedContracts()
        {
            return this.mutableContracts.filter(c => this.isContractModified(c) === true);
        },

        validateNewContractModal()
        {
            this.newContractFormErrors = [];

            if(!this.newContractForm.date_start)
            {
                this.newContractFormErrors.push("date_start");
            }

            if(this.newContractForm.type == 'new')
            {
                if(typeof this.newContractForm.copy_from == "undefined")
                {
                    this.newContractFormErrors.push("copy_from");
                }
            }

            return this.newContractFormErrors.length === 0;
        },

        checkWagePersonalNumber(timeout) {
            const contract = this.form;

            clearTimeout(this.checkWagePersonalNumberTimeouts[contract.id]);

            this.checkWagePersonalNumberTimeouts[contract.id] = setTimeout(() => {
                if (!contract.wage_personal_number) {
                    this.removeServerFieldError(contract, 'wage_personal_number');
                    return;
                }

                const snapshot = this.serverFieldSnapshot(contract, 'wage_personal_number');

                axios.post("check-wage-personal-number", { wage_personal_number: contract.wage_personal_number, date_start: contract.date_start, date_end: contract.date_end }).then(
                    (response) => {
                        // the number or the contract interval changed meanwhile, a newer check decides
                        if (this.serverFieldSnapshot(contract, 'wage_personal_number') !== snapshot) {
                            return;
                        }

                        if (!response.data.status && response.data.validationError) {
                            this.setServerFieldError(
                                contract,
                                'wage_personal_number',
                                response.data.validationErrorLocalized ? response.data.validationErrorLocalized : response.data.validationError,
                                snapshot
                            );
                        } else {
                            this.removeServerFieldError(contract, 'wage_personal_number');
                        }
                    },
                    () => {
                        this.$notify({
                            type: "error",
                            title: "Error!",
                            text: "An error has occured."
                        });
                    }
                );
            }, timeout);
        },

        isActiveContract(item)
        {
            return item.is_active && !item.is_draft;
        },

        compareObjects(ctr1, ctr2, sub)
        {
            try {
                const ctrObj1 = (sub ? ctr1 : JSON.parse(JSON.stringify(ctr1)));
                const ctrObj2 = (sub ? ctr2 : JSON.parse(JSON.stringify(ctr2)));

                for(var x in ctrObj1)
                {
                    if(typeof ctrObj1[x] === "object" || typeof ctrObj1[x] === "array")
                    {
                        if(typeof ctrObj2[x] === "undefined" || !this.compareObjects(ctrObj1[x], ctrObj2[x], true))
                        {
                            return false;
                        }
                    }
                    else if(typeof ctrObj1[x] == "number" || typeof ctrObj2[x] == "number")
                    {
                        if(parseFloat(ctrObj1[x]) !== parseFloat(ctrObj2[x]))
                        {
                            return false;
                        }
                    }
                    else if(""+ctrObj1[x] != ""+ctrObj2[x]) {
                        return false;
                    }
                }

            } catch(e) {
                console.log("Exception in Emp. form, method compareObjects(", ctr1, ", ", ctr2, "): ", e);
                return false;
            }

            return true;
        },

        // Server errors are kept per contract and field outside of the vee-validate bag, because validateAll()
        // (run on every contract switch and on submit) wipes the bag. An error stays visible while the field
        // (and the fields the server check depends on) still holds the value that was rejected.
        serverFieldDependencies(field) {
            return field === 'wage_personal_number' ? ['date_start', 'date_end'] : [];
        },

        serverFieldSnapshot(contract, field) {
            return JSON.stringify([field, ...this.serverFieldDependencies(field)].map(path => {
                const value = path.split('.').reduce((obj, key) => (obj === null || obj === undefined ? undefined : obj[key]), contract);

                // the wage personal number is an identifier, "01004" is not "1004"
                if (path === 'wage_personal_number') {
                    return (value === undefined || value === '') ? null : value;
                }

                return normalizeFormValue(value);
            }));
        },

        serverFieldError(field, contract = this.form) {
            const error = contract && (this.serverFieldErrors[contract.id] || {})[field];

            return error && error.snapshot === this.serverFieldSnapshot(contract, field) ? error.msg : null;
        },

        visibleServerFieldErrors(contract) {
            return Object.keys((contract && this.serverFieldErrors[contract.id]) || {})
                .map(field => ({field: field, msg: this.serverFieldError(field, contract)}))
                .filter(error => error.msg);
        },

        // server key -> input name, they differ for the salary additions only ("salary_addition.uniform" -> "uniform")
        serverFieldVvName(field) {
            return field.replace(/^salary_addition\./, '');
        },

        fieldError(field) {
            return this.errors.first(this.serverFieldVvName(field)) || this.serverFieldError(field);
        },

        hasFieldError(field) {
            return !!this.fieldError(field);
        },

        fieldClasses(field) {
            const classes = this.getValidationFieldClasses(this.fields, this.errors, this.serverFieldVvName(field)).split(' ');

            if (!this.serverFieldError(field)) {
                return classes;
            }

            return classes.filter(cls => cls !== 'has-success' && cls !== 'has-danger').concat('has-danger');
        },

        setServerFieldError(contract, field, msg, snapshot) {
            if (!this.serverFieldErrors[contract.id]) {
                this.$set(this.serverFieldErrors, contract.id, {});
            }

            this.$set(this.serverFieldErrors[contract.id], field, {msg: msg, snapshot: snapshot});
        },

        removeServerFieldError(contract, field) {
            if (this.serverFieldErrors[contract.id]) {
                this.$delete(this.serverFieldErrors[contract.id], field);
            }
        },

        // errors: [{contract: <copy of the submitted contract>, field: 'salary_addition.uniform', msg: '...'}]
        setServerFieldErrors(errors) {
            this.clearServerFieldErrors();

            errors.forEach(error => {
                this.setServerFieldError(error.contract, error.field, error.msg, this.serverFieldSnapshot(error.contract, error.field));
            });

            // show a contract with an error, unless the current one has some
            if (this.visibleServerFieldErrors(this.form).length === 0) {
                const contract = this.mutableContracts.find(ctr => this.visibleServerFieldErrors(ctr).length > 0);

                if (contract) {
                    this.setCurrentContract(contract.id);
                }
            }
        },

        clearServerFieldErrors() {
            this.serverFieldErrors = {};
        }
    },

    computed: {
        isRestaurantSelectDisabled() {
            if (this.formMode !== 'edit') {
                return true;
            }

            if (this.isMymcdSyncEnabled(this.mymcdSync)) {
                return true;
            }

            const existingContracts = this.contracts.filter(contract => contract.id !== -1 && contract.date_start);

            if (!this.form || this.form.id === -1 || existingContracts.length === 0) {
                return false;
            }

            const latestContract = existingContracts.reduce((latest, contract) => {
                if (!latest) {
                    return contract;
                }

                const latestDateStart = _moment(latest.date_start);
                const currentDateStart = _moment(contract.date_start);

                if (currentDateStart.isAfter(latestDateStart)) {
                    return contract;
                }

                if (currentDateStart.isSame(latestDateStart) && parseInt(contract.id) > parseInt(latest.id)) {
                    return contract;
                }

                return latest;
            }, null);

            return parseInt(this.form.id) !== parseInt(latestContract.id);
        },
        hasContractConcept() {
            return this.mutableContracts.some(c => c.id === -1 && c.parent_id === null);
        },
        hasAnyConcept() {
            return this.mutableContracts.some(c => c.id === -1);
        },

        // server errors of the current contract for fields that are not rendered (hidden or without an input)
        unplacedServerFieldErrors() {
            return this.visibleServerFieldErrors(this.form)
                .filter(error => !this.fields[this.serverFieldVvName(error.field)]);
        },

        wagePersonalNumberCheckState() {
            return JSON.stringify([
                this.form ? this.form.id : null,
                this.form ? this.serverFieldSnapshot(this.form, 'wage_personal_number') : null,
            ]);
        }
    },

    watch: {
        'form.date_start': function() {
            this.revalidateContractDateFields();
        },
        'form.date_end': function() {
            this.revalidateContractDateFields();
        },
        // re-check the wage personal number when it or the contract interval changes (not on a contract switch)
        wagePersonalNumberCheckState(state, previousState) {
            if (JSON.parse(state)[0] === JSON.parse(previousState)[0]) {
                this.checkWagePersonalNumber(500);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee-contract/Form.js